import PropTypes from "prop-types";
import React, {Fragment} from "react";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {compose} from "redux";
import {RTLProps} from "../../../../../../../shared/prop-types/ReducerProps";

class SkillTab extends React.Component{
    constructor(props){
        super(props);

        this.state = {
        }
    }

   render() {
        return (
            <Fragment>
                <div style={{marginTop : "20px", color: "#1D3B55"}}>
                    {this.props.skills}
                </div>
                <br/><br/>
            </Fragment>
        );
    }
}

SkillTab.propTypes = {
    t: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default compose(
    withTranslation("common"),
    connect((state) => ({
        rtl: state.rtl,
    }))
)(SkillTab);
